<template>
  <div class="position-manage">
    <page-header title="岗位管理" icon="el-icon-s-custom" />
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="岗位编码">
          <el-input v-model="searchForm.code" placeholder="请输入岗位编码" clearable class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="岗位名称">
          <el-input v-model="searchForm.name" placeholder="请输入岗位名称" clearable class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="岗位状态" clearable class="filter-item">
            <el-option label="正常" value="正常"></el-option>
            <el-option label="停用" value="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>
      
      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        
      </div>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="加载中..."
        @selection-change="handleSelectionChange"
        style="width: 100%"
        border
      >
        
       <el-table-column prop="code" label="岗位编码" width="100" align="center"></el-table-column>
        <el-table-column prop="name" label="岗位名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="岗位描述" width="200" align="center"></el-table-column>
        <el-table-column prop="sort" label="岗位排序" width="100" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '正常' ? 'success' : 'danger'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background>
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/修改岗位对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="岗位名称" prop="postName" required>
          <el-input v-model="form.postName" placeholder="请输入岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="岗位编码" prop="postCode" required>
          <el-input v-model="form.postCode" placeholder="请输入岗位编码"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位描述" prop="remark" required>
          <el-input v-model="form.remark" placeholder="请输入岗位描述"></el-input>
        </el-form-item> -->
        <el-form-item label="岗位顺序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" controls-position="right" placeholder="0"></el-input-number>
        </el-form-item>
        <el-form-item label="岗位状态">
          <el-radio-group v-model="form.status">
            <el-radio label="正常">正常</el-radio>
            <el-radio label="停用">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="岗位描述">
          <el-input type="textarea" v-model="form.remark" placeholder="请输入岗位描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'PositionManage',
  components: {
    PageHeader
  },
  data() {
    return {
      tableLoading: false,
      disabled:false,
      // 搜索表单
      searchForm: {
        code: '',
        name: '',
        status: ''
      },
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 选中的行
      multipleSelection: [],
      // 新增/修改对话框
      dialogVisible: false,
      dialogTitle: '',
      form: {
        postId: '',
        postName: '',
        postCode: '',
        sort: 0,
        status: '正常',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入岗位名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入岗位编码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 组件创建时获取数据
    this.fetchPositionList()
  },
  methods: {
    // 获取岗位列表
    async fetchPositionList() {
      this.tableLoading = true
      this.tableData = []
      this.total = 0
      try {
        const res = await request({
          url: '/api/v1/posts/list',
          method: 'POST',
          data: {
            postName: this.searchForm.name,
            postCode: this.searchForm.code,
            status: this.searchForm.status === '' ? -1 : 
                   this.searchForm.status === '正常' ? 1 : 0,
            page: this.currentPage,
            limit: this.pageSize,
          
            
          }
        })
        
        if (res.status === 1) {
          // 格式化数据
          this.tableData = res.data.map(item => ({
            id: item.postId,
            name: item.postName,
            code: item.postCode,
            sort: item.sort,
            status: item.status === 1 ? '正常' : '停用',
            createTime: this.formatDateTime(item.createdAt),
            remark: item.remark
          }))
          this.total = res.total
        }
      } catch (error) {
        console.error('获取岗位列表错误:', error)
        this.$message.error('获取岗位列表失败')
      }finally{
        this.tableLoading = false
      }

    },

    formatDateTime(date) {
      if (!date) return ''
      const d = new Date(date)
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    // 修改搜索方法
    handleSearch() {
      this.currentPage = 1
      this.fetchPositionList()
    },

    // 修改重置方法
    handleReset() {
      this.searchForm = {
        code: '',
        name: '',
        status: ''
      }
      this.currentPage = 1
      this.fetchPositionList()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '添加岗位'
      this.form = {
        postId: '',
        postName: '',
        postCode: '',
        sort: 0,
        status: '正常',
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    // 修改按钮（批量操作栏的修改按钮）
    handleModify() {
      if (this.multipleSelection.length !== 1) {
        this.$message.warning('请选择一条记录进行修改')
        return
      }
      const row = this.multipleSelection[0]
      this.handleEdit(row)
    },
    // 修改（表格行内的修改按钮）
    handleEdit(row) {
      console.log(row)
       this.dialogTitle = '修改岗位'
      this.form = {
        postId: row.id,
        postName: row.name,
        postCode: row.code,
        sort: row.sort,
        status: row.status,
        remark: row.remark || ''
      }
      this.dialogVisible = true
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    // 批量删除
    // async handleBatchDelete() {
    //   if (this.multipleSelection.length === 0) {
    //     this.$message.warning('请选择要删除的记录')
    //     return
    //   }

    //   try {
    //     await this.$confirm('确认删除选中的岗位?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     })
        
    //     const postIds = this.multipleSelection.map(item => item.id)
    //     const res = await request({
    //       url: '/api/v1/posts/delete',
    //       method: 'POST',
    //       data: {
    //         postIds: postIds
    //       }
    //     })

    //     if (res.status === 1) {
    //       this.$message.success('删除成功')
    //       this.fetchPositionList()
    //     }
    //   } catch (error) {
    //     if (error !== 'cancel') {
    //       console.error('批量删除岗位错误:', error)
    //       this.$message.error(error.message || '删除失败')
    //     }
    //   }
    // },
    // 导出
    handleExport() {
      console.log('导出数据')
    },
    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该岗位?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: '/api/v1/posts/delete',
          method: 'POST',
          data: {
            postId: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchPositionList()
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除岗位错误:', error)
          this.$message.error(error.message || '删除失败')
        }
      }
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 每页大小变化
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchPositionList()
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchPositionList()
    },
    // 提交表单
    async submitForm() {
      try {
        await this.$refs.form.validate()
        const res = await request({
          url: '/api/v1/posts/save',
          method: 'POST',
          data: {
            postId: this.form.postId,
            postName: this.form.postName,
            postCode: this.form.postCode,
            sort: this.form.sort,
            status: this.form.status === '正常' ? 1 : 0,
            remark: this.form.remark
          }
        })

        if (res.status === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchPositionList()
        }
      } catch (error) {
        console.error('保存岗位错误:', error)
        this.$message.error(error.message || '保存失败')
      }
    }
  }
}
</script>

<style scoped>
.position-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);
}

.search-card,
.table-card {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
}

.card-title {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.card-title i {
  margin-right: 8px;
  color: #409EFF;
}

.filter-item {
  width: 200px;
}

.filter-buttons {
  margin-left: 10px;
}

.operation-bar {
  margin: 0 20px 20px;
}

.el-table {
  margin: 0 20px 20px;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  padding: 12px 0;
}

.pagination-container {
  padding: 20px;
  text-align: right;
}

.el-button + .el-button {
  margin-left: 10px;
}
</style> 